export class JaegerTagsModel {
    accountId;
    tags;
}
//# sourceMappingURL=jaeger-tags.js.map